import { getLang } from '@union-investment/global-resources/src/utilities/language';
import store from './store';

// We use imported types only for the static helpers below
export interface FetchParameters {
  actionType: 'filters' | 'search';
  apiUrl: string;
  apiKey: string;
  apiVersion: string;
}

export function getUrlWithParams(actionType, apiUrl, apiVersion) {
  // Set action query param based on the actionType
  const action = actionType === 'filters' ? 'objectFilter' : 'objectSearch';

  const urlSearchParams = new URLSearchParams({
    action,
    lang: getLang(),
    'api-version': apiVersion,
  });

  // Add the selected filters to the URL
  const selectedFilters = { ...store.state.selectedFilters } || {};
  Object.entries(selectedFilters)
    .filter(([value]) => value !== '')
    .forEach(([key, value]) => {
      urlSearchParams.append(key, value);
    });

  const url = new URL(apiUrl);
  url.search = urlSearchParams.toString();

  return url.toString();
}

export function handleErrors(response) {
  if (!response.ok) {
    throw new Error(response.statusText);
  }
}

export async function fetchPropertyData({
  actionType,
  apiUrl,
  apiKey,
  apiVersion,
}: FetchParameters) {
  const url = getUrlWithParams(actionType, apiUrl, apiVersion);
  let data;
  try {
    store.state.fetchingData = true;
    if (actionType === 'search') store.state.fetchingProperties = true;
    const response = await fetch(url, {
      headers: {
        'x-api-key': apiKey,
      },
    });
    if (!response.ok) {
      data = handleErrors(response);
    }
    data = await response.json();
    store.state.fetchingData = false;
    if (actionType === 'search') store.state.fetchingProperties = false;
  } catch (error) {
    console.log(error);
  }

  return data;
}
